import React, { forwardRef } from 'react';
import { Dropdown } from 'react-bootstrap';

import InfoButton from '../InfoButton';

import './index.scss';

interface DashboardDropdownOption<T extends string> {
  value: T;
  label: string;
}

interface ChipToggleProps {
  rotulo: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  onMouseDown?: React.MouseEventHandler<HTMLButtonElement>;
  onKeyDown?: React.KeyboardEventHandler<HTMLButtonElement>;
  id?: string;
  'aria-haspopup'?: boolean | 'menu' | 'listbox' | 'tree' | 'grid' | 'dialog';
  'aria-expanded'?: boolean;
  'aria-labelledby'?: string;
}

const ChipToggle = forwardRef<HTMLButtonElement, ChipToggleProps>(
  (
    {
      rotulo,
      onClick,
      onMouseDown,
      onKeyDown,
      id,
      'aria-haspopup': ariaHasPopup,
      'aria-expanded': ariaExpanded,
      'aria-labelledby': ariaLabelledBy,
    },
    ref,
  ) => (
    <button
      ref={ref}
      type="button"
      id={id}
      className="agro-overview-chip-toggle"
      onClick={onClick}
      onMouseDown={onMouseDown}
      onKeyDown={onKeyDown}
      aria-haspopup={ariaHasPopup}
      aria-expanded={ariaExpanded}
      aria-labelledby={ariaLabelledBy}
    >
      <span className="agro-overview-chip-toggle__rotulo">{rotulo}</span>
      <span className="agro-overview-chip-toggle__caret" aria-hidden="true" />
    </button>
  ),
);
ChipToggle.displayName = 'AgroOverviewChipToggle';

export default function DashboardDropdown<T extends string>({
  label,
  value,
  onChange,
  options,
  onInfo,
}: {
  label: string;
  value: T;
  onChange: (next: T) => void;
  options: DashboardDropdownOption<T>[];
  onInfo?: () => void;
}) {
  const current = options.find((o) => o.value === value);

  return (
    <div className="agro-overview-dropdown">
      {/* Com botão (i) o label sobe de tamanho — proporcional aos 27px do
          botão (decisão 10/08/2026); sem (i), mantém o rótulo compacto. */}
      <div
        className={`agro-overview-dropdown__label${
          onInfo ? ' agro-overview-dropdown__label--com-info' : ''}`}
      >
        <span>{label}</span>
        {onInfo && <InfoButton onClick={onInfo} label={`Metodologia: ${label}`} />}
      </div>
      <Dropdown>
        <Dropdown.Toggle as={ChipToggle} rotulo={current?.label ?? 'Selecionar'} />
        <Dropdown.Menu className="agro-overview-dropdown-menu">
          {options.map((opt) => (
            <Dropdown.Item
              key={opt.value}
              onClick={() => onChange(opt.value)}
              className={`agro-overview-dropdown-item ${opt.value === value ? 'active' : ''}`}
            >
              {opt.label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
